import _ from 'lodash';

export const flattenArray = (years): number[] =>
  _.flattenDeep(years.map(({ year, items }) => items.map((item) => item.items.map(() => year))));
